import TransactionsController from './TransactionsController';
import { apiRequest } from '../utils/useAPIRequest';
import { appStore, walletStore } from '../stores';
import constant from '../utils/constant';

const walletDetails = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/wallets/new/business',
		method: 'get',
	});
	if (status === constant.Success) {
		walletStore.setWallets(data);
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const beneficiaries = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/banking/beneficiaries/business',
		method: 'get',
	});

	if (status === constant.Success) {
		const beneficiaries = data.beneficiaries.map(beneficiary => {
			return {
				key: beneficiary._id,
				value: {
					accountName: beneficiary.accountName,
					accountNumber: beneficiary.accountNumber,
					bankName: beneficiary.bankName,
					bankCode: beneficiary.bankCode,
				},
			};
		});
		appStore.setBeneficiaries(beneficiaries);
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const banks = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/banking/banks',
		method: 'get',
	});
	if (status === constant.Success) {
		const banks = data.banks.map(bank => {
			return { key: bank.bankCode, value: bank.bankName };
		});
		appStore.setBanks(banks);
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const verifyAccountNumber = async payload => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/banking/bank/verify-account-details',
		method: 'post',
		payload,
	});

	if (status === constant.Success) {
		await beneficiaries();
		return { status: constant.Success, data };
	}
	return { errorMessage, status };
};

const transferFund = async payload => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/banking/bank/fund-transfer',
		method: 'post',
		payload,
	});
	if (status === constant.Success) {
		await TransactionsController.transactions();
		await walletDetails();
		await beneficiaries();
		return { status: constant.Success };
	}
	return { errorMessage, status, data };
};


const fundForeignWallet = async payload => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/banking/create-funding-payment-link',
		method: 'post',
		payload,
	});
	if (status === constant.Success) {
		await TransactionsController.transactions();
		await walletDetails();
		return { status: constant.Success, data };
	}

	return { errorMessage, status, data };
};

const deleteBeneficiary = async id => {
	const { status, errorMessage } = await apiRequest({
		url: `/banking/beneficiary/${id}`,
		method: 'delete',
	});

	if (status === constant.Success) {
		await beneficiaries();
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const downloadAccountStatement = async payload => {
	const query = `startDate=${payload.startDate}&endDate=${payload.endDate}&currencyCode=${payload.currencyCode}`;

	const { status, errorMessage } = await apiRequest({
		url: `/transactions/accountStatement?${query}`,
		method: 'get',
	});

	if (status === constant.Success) {
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const getDynamicWalletFundingAccount = async query => {
	if (!query) {
		query = '';
	}

	const { status, errorMessage, data } = await apiRequest({
		url: `/bank-accounts/dynamic-wallet-funding?${query}`,
		method: 'get',
	});

	if (status === constant.Success) {
		walletStore.setDynamicAccountNumbers(data);
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const getWalletReceipt = async transferId => {
	const { status, errorMessage, data } = await apiRequest({
		url: `/banking/banking/transfer-receipts/${transferId}`,
		method: 'get',
	});

	if (status === constant.Success) {
		return { status: constant.Success, data };
	}
	return { errorMessage, status };
};

const WalletController = {
	beneficiaries,
	transferFund,
	verifyAccountNumber,
	banks,
	walletDetails,
	fundForeignWallet,
	deleteBeneficiary,
	downloadAccountStatement,
	getDynamicWalletFundingAccount,
	getWalletReceipt,
};

export default WalletController;
